import { __, sprintf } from "@wordpress/i18n";
export const PopupWrapper = ({ children, step, wrapperClass }) => {
  return (
    <div className="sbc-fb-source-ctn sb-fs-boss sbc-fb-center-boss">
      <div
        data-step={step}
        className={`${
          wrapperClass ?? "sbc-fb-source-popup"
        } sbc-fb-popup-inside`}
      >
        {children}
      </div>
    </div>
  );
};

export const PopupCloseButton = ({ hideCallback }) => {
  return (
    <div className="sbc-fb-popup-cls" onClick={hideCallback}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
          fill="#141B38"
        />
      </svg>
    </div>
  );
};

export const SourcesRedirectPopup = () => {
  return (
    <PopupWrapper step="redirect_1">
      <div className="sb-fb-source-redirect sb-fb-fs">
        <div className="sb-fb-source-redirect-ld sb-fb-fs">
          <div></div>
        </div>
        <div className="sb-fb-source-redirect-info sb-fb-fs">
          <strong className="sb-fb-fs">
            {__("Redirecting to connect.smashballoon.com", "feeds-for-youtube")}
          </strong>
          <p className="sb-fb-fs">
            {__(
              "You will be redirected to our app so you can connect your account in 5 seconds",
              "feeds-for-youtube"
            )}
          </p>
        </div>
      </div>
    </PopupWrapper>
  );
};

export const SourcesDeletePopup = ({ username, callback, hideCallback }) => {
  return (
    <PopupWrapper wrapperClass="sb-dialog-popup">
      <PopupCloseButton hideCallback={hideCallback} />

      <div className="sb-dialog-popup-content sbc-fb-fs">
        <strong>
          {sprintf(__("Delete %s?", "feeds-for-youtube"), username)}
        </strong>
        <span>
          {__(
            "Are you sure you want to delete this channel?",
            "feeds-for-youtube"
          )}
        </span>
        <div className="sb-dialog-popup-actions sbc-fb-fs">
          <button
            className="sb-btn sb-btn-blue"
            onClick={(evt) => {
              evt.preventDefault();
              callback();
              hideCallback();
            }}
          >
            {__("Confirm", "feeds-for-youtube")}
          </button>
          <button
            className="sb-btn sb-btn-red"
            onClick={(evt) => {
              evt.preventDefault();
              hideCallback();
            }}
          >
            {__("Cancel", "feeds-for-youtube")}
          </button>
        </div>
      </div>
    </PopupWrapper>
  );
};
